<script setup lang="ts">
import { useWindowSize } from "@vueuse/core";

const localePath = useLocalePath();
const { isMenuOpen, selectedLocation } = storeToRefs(useBusinessStore());
const { width } = useWindowSize();
const { isLoggedIn } = useAuth();
const globalStore = useGlobalStore();
const { goingToSignInFromRoute } = storeToRefs(globalStore);
const route = useRoute();

const handleSignIn = (): void => {
  goingToSignInFromRoute.value = route.fullPath;
  globalStore.openSignInModal();
};
</script>

<template>
  <div
    :class="{
      'opacity-0 invisible pointer-events-none': isMenuOpen && width < 1024,
      'bg-primary-400': selectedLocation?.theme_name === 'monochrome',
      'bg-primary-500': selectedLocation?.theme_name !== 'monochrome',
    }"
    class="w-full h-90 xs:h-100 lg:h-full relative"
    style="background-image: url('/vector.svg')"
    >

    <div
      v-if="selectedLocation?.cover"
      class="absolute inset-0 overflow-hidden">
      <div
        class="absolute inset-0 bg-cover bg-no-repeat bg-bottom animate-blurFade"
        :style="{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${selectedLocation?.cover})`,
          filter: 'blur(4px)',
          transform: 'scale(1.05)'
        }" />
    </div>

    <div class="flex justify-between relative z-10 overflow-hidden px-4 xs:px-5 py-4 xs:py-5">
      <div class="hidden lg:flex">
        <ULink :to="localePath('/')">
          <img src="/l-h-logo.svg" alt="bookforme" class="w-43 xs:w-auto">
        </ULink>
      </div>
      <div class="hidden lg:flex lg:items-center lg:gap-x-2">
        <UButton
          v-if="!isLoggedIn"
          :label="$t('label.sign_in')"
          size="xl"
          :trailing="true"
          color="dodger-blue"
          :ui="{ rounded: 'rounded-full', size: { xl: 'lg:text-base' }, gap: { xl: 'gap-x-1' }, padding: { xl: 'px-3 xs:px-3.5 py-2 xs:py-2.5' } }"
          @click="handleSignIn" />
        <div class="inline-block">
          <CommonLanguagesMenu />
        </div>
        <CommonClientDropdown v-if="isLoggedIn" />
      </div>
    </div>
  </div>
</template>
